var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.componentType)?_c('div',[_vm._v("\n\tError: component '"+_vm._s(_vm.routingComponentName)+"' not found\n")]):_c(_vm.componentType,{tag:"component",attrs:{"global_style":_vm.currentLayout.global_style}})}
var staticRenderFns = []

export { render, staticRenderFns }